import { OrderStatus } from "client/api-v2";

export function orderStatusLabel(status: OrderStatus): string {
  return status === OrderStatus.Cancelled ? "Canceled" : status;
}
